module.exports = __webpack_public_path__ + "static/raj_1-a8e3d1f4fe5ae1dfb47bdb2a21234a8e.png";